import FormTypes from 'forms-utils-lib/constants/formDefinition/FormTypes';
import { SOURCE_APP } from 'asset-actions-lib-forms/constants/app';
const FORM_TYPE_TO_SOURCE_APP_NAME_MAP = {
  [FormTypes.HUBSPOT]: SOURCE_APP.FORMS_APP,
  [FormTypes.FLOW]: SOURCE_APP.LEAD_FLOWS_APP
};
const isHubSpotOrFlowType = formType => formType === FormTypes.HUBSPOT || formType === FormTypes.FLOW;
export const getSourceAppNameFromFormType = formType => isHubSpotOrFlowType(formType) ? FORM_TYPE_TO_SOURCE_APP_NAME_MAP[formType] : FORM_TYPE_TO_SOURCE_APP_NAME_MAP.HUBSPOT;